<div [class]="tableOptions.redirectButtonLabel && tableOptions.redirectButtonLink ? '' : 'row pb-3'">
  <div class="col d-flex justify-content-end">
    <jhi-bary-button
      *ngIf="tableOptions.redirectButtonLabel && tableOptions.redirectButtonLink"
      class="mr-2"
      icon="file"
      [label]="tableOptions.redirectButtonLabel | translate"
      [outline]="true"
      [routerLink]="tableOptions.redirectButtonLink"
    ></jhi-bary-button>
    <jhi-bary-button
      *ngIf="tableOptions.createModalLabel || tableOptions.createAndRedirectModalLabel"
      icon="plus"
      [label]="tableOptions.createButtonLabel || 'BTN.NEW' | translate"
      (clickEvent)="openAddNew(false)"
    ></jhi-bary-button>
  </div>
</div>
